import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@applyboard/ui-components';
import CriteriaDetailTableRow from "./CriteriaDetailTableRow";
import CriteriaEnglishDetailTableRow from "./CriteriaEnglishDetailTableRow";
import { EligibilityStatus } from "../../data";
import { ErrorIcon, SuccessIcon, WarningIcon } from "./Icons";
import CriteriaDetailWithSubscores from "./CriteriaDetailWithSubscores";
var IneligibilityReasons = function IneligibilityReasons(_ref) {
  var reasons = _ref.reasons;
  if (!Array.isArray(reasons)) return null;
  if (reasons.length <= 0) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, reasons.map(function (r) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/jsx-key
      React.createElement("p", null, r)
    );
  }));
};
var CheckEligibilityData = function CheckEligibilityData(_ref2) {
  var _eligibility$criteria, _eligibility$criteria2, _eligibility$criteria3, _eligibility$criteria4, _eligibility$criteria5, _eligibility$criteria6, _eligibility$criteria7, _eligibility$criteria8;
  var eligibility = _ref2.eligibility;
  var icon;
  var label;
  var description = '';
  switch (eligibility.eligibility) {
    case EligibilityStatus.Eligible:
      label = 'Student is eligible for this program.';
      icon = /*#__PURE__*/React.createElement(SuccessIcon, null);
      break;
    case EligibilityStatus.Ineligible:
      label = 'Student is not eligible to apply for this program.';
      icon = /*#__PURE__*/React.createElement(ErrorIcon, null);
      description = /*#__PURE__*/React.createElement(IneligibilityReasons, {
        reasons: eligibility.ineligibleReasons
      });
      break;
    case EligibilityStatus.Conditional:
      label = 'Student is eligible with a condition.';
      icon = /*#__PURE__*/React.createElement(SuccessIcon, null);
      description = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, "This program requires the student to complete an", ' ', /*#__PURE__*/React.createElement("strong", null, "English as a Second Language (ESL)"), " course."), /*#__PURE__*/React.createElement("p", null, "The student will need to enroll and complete this course prior to starting this academic program."));
      break;
    case EligibilityStatus.Unknown:
    default:
      icon = /*#__PURE__*/React.createElement(WarningIcon, null);
      label = 'We cannot determine the student eligibility to this program';
      break;
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, icon), " ", /*#__PURE__*/React.createElement("span", {
    "data-testid": "result-label"
  }, label)), /*#__PURE__*/React.createElement("div", null, description), eligibility.intakeAvailable === false && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(WarningIcon, null)), ' ', /*#__PURE__*/React.createElement("span", {
    "data-testid": "no-intake-label"
  }, "No intakes are currently available.")), eligibility.eligibility === EligibilityStatus.Ineligible && /*#__PURE__*/React.createElement(Table, {
    "aria-label": "eligibility results"
  }, /*#__PURE__*/React.createElement(TableHead, {
    style: {
      textTransform: 'uppercase'
    }
  }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "Criteria"), /*#__PURE__*/React.createElement(TableCell, null, "Requirements"), /*#__PURE__*/React.createElement(TableCell, null, "Student Scores"))), /*#__PURE__*/React.createElement(TableBody, null, /*#__PURE__*/React.createElement(CriteriaDetailTableRow, {
    criteria: eligibility === null || eligibility === void 0 ? void 0 : (_eligibility$criteria = eligibility.criteria) === null || _eligibility$criteria === void 0 ? void 0 : _eligibility$criteria.educationLevel,
    label: "Education Level"
  }), /*#__PURE__*/React.createElement(CriteriaEnglishDetailTableRow, {
    criteria: eligibility === null || eligibility === void 0 ? void 0 : (_eligibility$criteria2 = eligibility.criteria) === null || _eligibility$criteria2 === void 0 ? void 0 : _eligibility$criteria2.engTest,
    label: (eligibility === null || eligibility === void 0 ? void 0 : (_eligibility$criteria3 = eligibility.criteria) === null || _eligibility$criteria3 === void 0 ? void 0 : (_eligibility$criteria4 = _eligibility$criteria3.engTest) === null || _eligibility$criteria4 === void 0 ? void 0 : (_eligibility$criteria5 = _eligibility$criteria4.type) === null || _eligibility$criteria5 === void 0 ? void 0 : _eligibility$criteria5.toUpperCase()) || 'English Test'
  }), /*#__PURE__*/React.createElement(CriteriaDetailWithSubscores, {
    criteria: eligibility === null || eligibility === void 0 ? void 0 : (_eligibility$criteria6 = eligibility.criteria) === null || _eligibility$criteria6 === void 0 ? void 0 : _eligibility$criteria6.gmat,
    label: "GMAT"
  }), /*#__PURE__*/React.createElement(CriteriaDetailWithSubscores, {
    criteria: eligibility === null || eligibility === void 0 ? void 0 : (_eligibility$criteria7 = eligibility.criteria) === null || _eligibility$criteria7 === void 0 ? void 0 : _eligibility$criteria7.gre,
    label: "GRE"
  }), /*#__PURE__*/React.createElement(CriteriaDetailTableRow, {
    criteria: eligibility === null || eligibility === void 0 ? void 0 : (_eligibility$criteria8 = eligibility.criteria) === null || _eligibility$criteria8 === void 0 ? void 0 : _eligibility$criteria8.gpa,
    label: "GPA"
  }))));
};
export default CheckEligibilityData;